/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';
import pagesMap from './pages-map';

Vue.use(Vuex);

const storage = sessionStorage;
const store = new Vuex.Store({
  state: {
    menuList: [],
    featureList: [],
    await: true, // 等待状态
    temp: '',
    pageTab: [{ path: '/Home', name: '客户列表' }],
    activeName: '/Home',
    pageIndex: 0,
    topath: '',
    custCis: '',
    homepath: '',
    pageSize: 10,
    loadingStatus: false,
    userInfo: '',
    userId: '',
    userToken: '',
    wpspUserInfo: {},
    wpspCustInfo: {},
    wpspamiFliList: {},
    wpspAddSpouse: '',
    wpspWhichComp: 'basicMain', // 控制选择加载哪个组件,basicMain是默认加载基本信息页面
    wpspChildStepStatys: false, // 测算过是可以下一步
  },
  mutations: {
    setChildStepStatys: (state, userInfo) => {
      state.wpspChildStepStatys = userInfo;
    },
    setChildrenWhichComp: (state, userInfo) => {
      state.wpspWhichComp = userInfo;
    },
    setAddSpouse: (state, userInfo) => {
      console.warn('store的打印--', userInfo);
      state.wpspAddSpouse = userInfo;
    },
    setUserInfo: (state, userInfo) => {
      state.wpspUserInfo = userInfo;
    },
    setFamiliList: (state, userInfo) => {
      state.wpspamiFliList = userInfo;
    },
    setMenuList(state, menuList) {
      state.menuList = menuList;
      storage.setItem('menuList', JSON.stringify(menuList || null));
    },
    setFeatureList(state, featureList) {
      state.featureList = featureList;
      storage.setItem('featureList', JSON.stringify(featureList || null));
    },
    setToken(state, token) {
      state.userToken = token;
      storage.setItem('userToken', JSON.stringify(token || null));
    },
    setUserId(state, id) {
      state.userId = id;
      storage.setItem('userId', JSON.stringify(id || null));
    },
    removeTab(state, path) {
      if (path === '/Home') {
        return;
      }
      const deleteTabIndex = state.pageTab.findIndex(item => item.path === path);
      const activeIndex = state.pageTab.findIndex(item => item.path === state.activeName);
      if (activeIndex === deleteTabIndex) {
        const activeTab = state.pageTab[deleteTabIndex - 1];
        state.activeName = activeTab.path;
      }
      state.pageTab = state.pageTab.filter(item => item.path !== path);
    },
    addTab(state, tab) {
      const paths = state.pageTab.map(item => item.path);
      if (!paths.includes(tab.path)) {
        state.pageTab.push(tab);
        if (state.pageTab.length > 17) {
          state.pageTab.splice(1, 1);
        }
      }
      state.activeName = tab.path;
    },
    clearTab(state) {
      state.pageTab = [];
    },
    setActiveTab(state, v) {
      state.activeName = v;
    },
    resetPageTab(state) {
      state.pageTab = [{ path: '/Home', name: '主页' }];
      state.activeName = '/Home';
    },
  },
  getters: {
    getChildStepStatys: state => state.wpspChildStepStatys,
    getChildrenWhichComp: state => state.wpspWhichComp,
    menuList(state) {
      return state.menuList && state.menuList.length
        ? state.menuList
        : JSON.parse(storage.getItem('menuList') || '[]');
    },
    featureList(state) {
      return state.featureList && state.featureList.length
        ? state.featureList
        : JSON.parse(storage.getItem('featureList') || '[]');
    },
    userInfo(state) {
      return state.userInfo;
    },
    keepAlivePages(state) {
      const { pageTab } = state;
      return pagesMap
        .filter(page => pageTab.map(tab => tab.path).includes(page.path))
        .map(page => page.name);
    },
    userToken(state) {
      return state.userToken || JSON.parse(storage.getItem('userToken'));
    },
    userId(state) {
      return state.userId || JSON.parse(storage.getItem('userId'));
    },
    workNo() {
      return JSON.parse(storage.getItem('sessionData')) ?.workNo;
    },
  },
  actions: {
    changeGlobalState(state, status) {
      state.loadingStatus = status;
    },
  },
});
export default store;
